import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store';
import Cookies from 'js-cookie';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes, // short for routes: routes
    linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
    const userLoggedIn = store.getters.getUser;
    const token = Cookies.get('access_token');

    alert(to);
    // Auth routes
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (userLoggedIn && token) {
            next();
        } else {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath,
                },
            });
        }
    } else if(to.matched.some(record => record.meta.guest)) { // Unauthenticated routes
        if (userLoggedIn && token) {
            next({path: '/'});
        } else {
            next();
        }
    } else {
        next();
    }
})

export default router;